export const ROTAS_DIAGNOSTICO_SOCIOAMBIENTAL = [
    'DiagnosticoSocioambiental',
    'DiagnosticoSocioambientalV2'
];
